import type { MailMessageSummary } from "@/lib/types/mail";

function normalizeSearchText(value: string): string {
  return value.trim().toLowerCase();
}

/** Tokens AND — aligné sur une recherche « contient » simple (P0, hors IMAP). */
export function messageMatchesLocalSearch(message: MailMessageSummary, query: string): boolean {
  const normalized = normalizeSearchText(query);
  if (!normalized) return true;

  const haystack = normalizeSearchText(
    [message.subject, message.from, message.sendTo ?? ""].filter(Boolean).join(" ")
  );
  const tokens = normalized.split(/\s+/).filter(Boolean);
  return tokens.every((token) => haystack.includes(token));
}

export function filterMessagesLocalSearch(
  messages: MailMessageSummary[],
  query: string
): MailMessageSummary[] {
  const normalized = normalizeSearchText(query);
  if (!normalized) return messages;
  return messages.filter((message) => messageMatchesLocalSearch(message, query));
}

export function mergeSearchResultsByUid(
  local: MailMessageSummary[],
  server: MailMessageSummary[]
): MailMessageSummary[] {
  if (server.length === 0) return local;
  if (local.length === 0) return server;

  const map = new Map<number, MailMessageSummary>();
  for (const message of local) {
    if (message.uid > 0) map.set(message.uid, message);
  }
  for (const message of server) {
    if (message.uid > 0) map.set(message.uid, message);
  }
  return [...map.values()].sort((a, b) => b.uid - a.uid);
}
